<script>
import moment from 'moment'
import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import {
    required,
    minLength,
    maxLength,
    maxValue

} from 'vuelidate/lib/validators'
 const soloPDF = (value) => value === "application/pdf" 
/**
 * Inscripción documento
 */
export default {
    components: {
        Layout,
        PageHeader,
        Multiselect,
        DatePicker,
    },
    page: {
        title: 'Inscripción',
        meta: [{
            name: 'description',
            content: appConfig.description
        }],
    },
    data() {
        return {
            title: 'Inscripción',
            form: {
                idDocumento: '',
                nombre: '',
                nombreArchivo: '',
                tipoDocumento: null,
                organismo: null,
                valoresMetadatos: [],
                informacionReservada: false,
                archivo: null
            },
            requestComboOrganismos: {
                perPage: 100,
                cuerrentPage: 0,
                filter: ""
            },
            requestComboTipoDocumentos: {
                perPage: 100,
                cuerrentPage: 0,
                filter: ""
            },
            archivoSeleccionado:{
              tamano:0,
              tipo:"" 
            },
            isLoadingCombo: false,
            isLoadingComboTipoDocumentos: false,
            listadoTipoDocumentos: [],
            listadoOrganismos: [],
            items: [{
                    text: 'REPODECAM',
                    href: '/',
                },
                {
                    text: 'Documentos',
                    href: '/documentos/add',
                },
                {
                    text: 'Inscripción',
                    active: true,
                },
            ],
            submitted: false,
            isBusy: false
        }
    },
    validations: {
        form: {
            nombre: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(255)
            },
            organismo: {
                required,
            },
            tipoDocumento: {
                required,
            },
            valoresMetadatos: {
              $each:{
                valor:{
                  required
                }
              }
            }
        },
        archivoSeleccionado:{
          tamano:{
            required,
            maxValue : maxValue(50)
           
          },
          tipo :{
            required,
            soloPDF
          
          }

        }
    },
    computed: {

    },
    mounted() {
        this.loadOrganismos();
        this.loadTiposDocumentos();

    },
    methods: {
        tipoDocumentoSeleccionado(value) {
            axios
                .get(appConfig.recursosApi.tipoDocumento + "/metadato/" + value.id)
                .then((response) => {
                    this.form.valoresMetadatos = response.data;                    
                })
                .catch(() => {
                    this.form.valoresMetadatos = [];
                    // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                    this.$router.push('/500');

                });
        },
        handleFileUpload(e) {
            this.form.archivo = this.$refs.fileDocumento.files[0];
            if(this.$refs.fileDocumento.files.length > 0){
              this.archivoSeleccionado.tamano = (this.$refs.fileDocumento.files[0].size / 1024) / 1024
            this.archivoSeleccionado.tipo = this.$refs.fileDocumento.files[0].type

            }
            
            
        },

        loadOrganismos(query = "") {
            this.isLoadingCombo = true;
            this.requestComboOrganismos.filter = query;
            axios
                .get(appConfig.recursosApi.organismo, {
                    params: this.requestComboOrganismos
                })
                .then((response) => {
                    this.listadoOrganismos = response.data.result;
                    this.isLoadingCombo = false;
                    return this.data
                })
                .catch(() => {
                    this.listadoOrganismos = [];
                    this.isLoadingCombo = false;
                    // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                    this.$router.push('/500');
                });
        },
        loadTiposDocumentos(query = "") {
            this.isLoadingComboTipoDocumentos = true;
            this.requestComboTipoDocumentos.filter = query;
            axios
                .get(appConfig.recursosApi.tipoDocumento, {
                    params: this.requestComboOrganismos
                })
                .then((response) => {
                    this.listadoTipoDocumentos = response.data.result;
                    this.isLoadingComboTipoDocumentos = false;
                    return this.data
                })
                .catch(() => {
                    this.listadoTipoDocumentos = [];
                    this.isLoadingComboTipoDocumentos = false;
                    this.$router.push('/500');
                });
        },
        handleSubmit(e) {
            this.submitted = true
            if (!this.$v.$invalid) {
                this.isBusy = true;
                let formData = new FormData();
                formData.append('nombre', this.form.nombre);
                formData.append('idTipoDocumento', this.form.tipoDocumento.id);
                formData.append('idOrganismo', this.form.organismo.id);
                formData.append('archivo', this.$refs.fileDocumento.files[0]);
                this.form.valoresMetadatos.forEach(function (key, value) {
                    formData.append('valores.Index', value);
                    formData.append('valores[' + value + '].idMetadato', key.idMetadato);
                    if (key.tipo === "Fecha") {
                        formData.append('valores[' + value + '].valor', moment(key.valor).format('DD/MM/YY'));
                    } else if (key.tipo === "Lista") {
                        formData.append('valores[' + value + '].valor', key.valor.valor);
                    } else {
                        formData.append('valores[' + value + '].valor', key.valor);
                    }
                });

                return axios
                    .post(appConfig.recursosApi.documento, formData, {
                        'Accept': 'application/json',
                        'Content-Type': 'multipart/form-data',
                    }, )
                    .then((response) => {
                        this.$router.push('/documentos/exito');
                        this.isBusy = false;
                    }).catch(() => {
                        Vue.swal({
                            type: 'error',
                            title: 'Oops...',
                            text: 'Ocurrio un error al intentar guardar los datos.',
                            confirmButtonClass: 'btn btn-confirm mt-2',
                        });
                        this.isBusy = false;
                    });
            }
            this.$v.$touch();

        },
    }

}
</script>
<template lang="es">
<Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-lg-6">
            <div class="card-box">
                <h4 class="header-title m-t-0">Inscripción Documento</h4>
                <p class="text-muted font-14 m-b-20">Ingresa la información del documento.</p>

                <form @submit.prevent="handleSubmit">

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="example-fileinput">Selecciona el Documento</label>
                            <input id="documento" class="form-control" ref="fileDocumento" type="file" accept=".pdf" @change="handleFileUpload" :class="{ 'is-invalid': submitted && $v.archivoSeleccionado.$error }" />
                            <div v-if="submitted && !$v.archivoSeleccionado.tipo.required" style="display:block;" class="invalid-feedback">Debe seleccionar un archivo.</div>
                            <div v-if="submitted && !$v.archivoSeleccionado.tipo.soloPDF" style="display:block;" class="invalid-feedback">Solo se permiten archivos PDF.</div>
                            <div v-if="submitted && !$v.archivoSeleccionado.tamano.maxValue" style="display:block;" class="invalid-feedback">El tamaño maximo del archivo debe ser de 50 Mb.</div>
                        </div>
                    </div>
                    <!-- Organismo y Rol -->
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="organismo">Organismo </label>
                            <multiselect id="organismo" v-model="form.organismo" label="nombre" track-by="id" placeholder="Teclea el nombre del organismo" open-direction="bottom" deselect-label=" X " select-label=" + " selected-label=" Seleccionado" :options="listadoOrganismos" :multiple="false" :searchable="true" :loading="isLoadingCombo" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="100" :limit="3" :max-height="500" :show-no-results="true" :hide-selected="false" :class="{ 'is-invalid': submitted && $v.form.organismo.$error }" @search-change="loadOrganismos">
                                <span slot="noResult">No se encontraron resultados.</span>
                                <span slot="noOptions">No se encontraron organismos.</span>

                            </multiselect>
                            <div v-if="submitted && !$v.form.organismo.required" style="display:block;" class="invalid-feedback">Debe seleccionar el organismo.</div>

                        </div>
                    </div>

                    <!-- Organismo y Rol -->
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="tipoDocumento">Tipo Documento </label>
                            <multiselect id="tipoDocumento" v-model="form.tipoDocumento" label="descripcion" track-by="id" placeholder="Teclea el nombre del tipo documento." open-direction="bottom" deselect-label=" X " select-label=" + " selected-label=" Seleccionado" :options="listadoTipoDocumentos" :multiple="false" :searchable="true" :loading="isLoadingComboTipoDocumentos" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="100" :limit="3" :class="{ 'is-invalid': submitted && $v.form.tipoDocumento.$error }" :max-height="500" :show-no-results="true" :hide-selected="false" @select="tipoDocumentoSeleccionado" @search-change="loadTiposDocumentos">
                                <span slot="noResult">No se encontraron resultados.</span>
                                <span slot="noOptions">No se encontraron tipos documentos.</span>

                            </multiselect>
                            <div v-if="submitted && !$v.form.tipoDocumento.required" style="display:block;" class="invalid-feedback">Debe seleccionar el tipo de documento.</div>

                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="name">
                                Nombre del documento
                                <span class="text-danger">*</span>
                            </label>
                            <input id="nombre" v-model="form.nombre" name="nombre" class="form-control" :class="{ 'is-invalid': submitted && $v.form.nombre.$error }" type="text" placeholder="" />
                            <div v-if="submitted && !$v.form.nombre.required" class="invalid-feedback">Debe ingresar el nombre del documento.</div>
                            <div v-if="submitted && !$v.form.nombre.minLength" class="invalid-feedback">El tamaño minimo del nombre es de 4 caracteres.</div>

                            <div v-if="submitted && !$v.form.organismo.maxLength" class="invalid-feedback">El tamaño maximo del nombre es de 255 caracteres.</div>

                        </div>
                    </div>

                    <div class="form-row">
                        <div v-for="(item, index) in $v.form.valoresMetadatos.$each.$iter" :key="item.idMetadato" class="form-group col-md-4">
                            <label for="name">
                                {{ form.valoresMetadatos[index].descripcion }}

                                <span class="text-danger">*</span>
                            </label>
                            <input v-if="form.valoresMetadatos[index].tipo === 'String'" :key="index" v-model="form.valoresMetadatos[index].valor" class="form-control" type="text" placeholder=""   :class="{ 'is-invalid': submitted && item.valor.$invalid }" />
                            <date-picker v-else-if="form.valoresMetadatos[index].tipo === 'Fecha'" v-model="form.valoresMetadatos[index].valor" :first-day-of-week="1" format="DD/MM/YY" lang="es"  :class="{ 'is-invalid': submitted && item.valor.$invalid }" ></date-picker>

                            <multiselect v-else-if="form.valoresMetadatos[index].tipo === 'Lista'" v-model="form.valoresMetadatos[index].valor" label="descripcion" track-by="valor" placeholder="" deselect-label=" X " select-label=" + " selected-label=" Seleccionado" :options="form.valoresMetadatos[index].listado"  :class="{ 'is-invalid': submitted && item.valor.$invalid }">
                                <span slot="noResult">No se encontraron resultados.</span>
                                <span slot="noOptions">No se encontraron valores.</span>
                            </multiselect>
                             <div  v-if="submitted && item.valor.$invalid"  class="invalid-feedback" style="display:block;" > {{form.valoresMetadatos[index].descripcion }}  es requerido.</div>

                        </div>
                    </div>

                    <div class="form-group text-right m-b-0">
                        <button class="btn btn-primary" type="submit" :disabled="isBusy">
                            <b-spinner v-show="isBusy" small></b-spinner> Guardar
                        </button>
                        <router-link class="btn btn-secondary m-l-5 ml-1" to="/"> Cancelar</router-link>
                    </div>
                </form>
            </div>
            <!-- end card-box -->
        </div>
    </div>
</Layout>
</template>
